export default (a: number, b: number) => Math.sqrt(a ** 2 + b ** 2);
